<input #topAnchor matInput type="text" [readonly]="true" class="discoveryProcess_hiddenInput">
<app-progress-bar
    *ngIf="!isDiscoveryAlreadyDone"
    class="discoveryProcess_progessBar"
    [value]="progressBarValue"
></app-progress-bar>
<div class="discoveryWizard_container">
    <div *ngIf="isDiscoveryAlreadyDone" class="discoveryWizard_doneContainer">
        <mat-icon class="discoveryWizard_doneIcon">check_circle</mat-icon>
        <span class="discoveryWizard_doneText">{{ 'discoveryProcess.discoveryCompleted' | translate }}</span>
        <button mat-raised-button color="primary" class="structuredProcess_nextStepButton" (click)="continueToNextStep()">
            {{ 'personal.continueToNextStep' | translate }}
            <mat-icon class="structuredProcess_nextStepIcon">arrow_forward</mat-icon>
        </button>
    </div>
    <div *ngIf="questionList.length > 0 && !isDiscoveryAlreadyDone" class="discoveryWizard_currentQuestionContainer">
        <app-discovery-wizard-current-question *ngIf="questionList[currentQuestionPos].type==eDiscoveryQuestionTypeEnum.Standard" class="discoveryWizard_currentQuestion"
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]"
            [presentConsultantVideo]="presentConsultantQuestionsVideo"
            (sendQuestionResponseEvent)=setQuestionResponse($event)>
        </app-discovery-wizard-current-question>
        <app-discovery-wizard-current-question-gap *ngIf="questionList[currentQuestionPos].type==eDiscoveryQuestionTypeEnum.MotivationGap" class="discoveryWizard_currentQuestion"
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]"
            (sendQuestionResponseEvent)=setQuestionMotivationResponse($event)>
        </app-discovery-wizard-current-question-gap>
        <app-discovery-wizard-current-question-tail *ngIf="questionList[currentQuestionPos].type==eDiscoveryQuestionTypeEnum.TailResolution" class="discoveryWizard_currentQuestion"
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]"
            [presentConsultantVideo]="presentConsultantQuestionsVideo"
            (sendQuestionResponseEvent)=setQuestionTailResponse($event)>
        </app-discovery-wizard-current-question-tail>
    </div>
</div>
